<template>
  <a-modal
    :title="name"
    :width="500"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="24" :sm="12">
            <a-form-item
              label="旧密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-password type="password"
                       @blur.prevent="changeOld()"
                       placeholder="请输入旧密码"
                       v-decorator="['oldPassword', {rules: [{required: true, message: '密码不能为空！'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="新密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-password type="password"
                                placeholder="请输入新密码"
                                v-decorator="['password', {rules: [{required: true, message: '密码不能为空！'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="12">
            <a-form-item
              label="确认密码"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input-password
                placeholder="请输入确认密码"
                @blur.prevent="changeCount()" type="password"
                                v-decorator="['comfPassword', {rules: [{required: true, message: '确认密码不能为空！'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col align="center" v-if="mode != 'view'" :md="24" :sm="24">
            <a-button @click="handleSubmit" type="primary">提交</a-button>
            <a-button @click="handleCancel" style="margin-left: 10px">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
      <common-alert ref="commonAlert"/>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import {postAxios, getAxios} from '@/api/request'
  import commonAlert from '../../common/commonAlert.vue'

  const formList = {
    name: '',
    phone: '',
    sex: '',
    authAdmin: '',
    authSetting: '',
    authReport: '',
    authPostSale: '',
    authGive: '',
    remark: '',
    id: '',
    shopNo: '',
    staffNo: '',
    oldPassword: ''
  }
  export default {
    name: 'shopAdd',
    components: {
      commonAlert
    },
    data() {
      return {
        // 验证组件
//        fieldRule,
        name: '',
        mode: '',
        formData: {...formList},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        shopData: [
          {
            'shopNo': '',
            'name': '全部'
          }
        ],
        originalShopData: {
          'shopNo': '',
          'name': '全部'
        },
        visible: false,
        confirmLoading: false,
        oldPassword: '',
        form: this.$form.createForm(this) // 注册后，才能通过表单拉取数据
      }
    },
    watch: {
      // oldPassword: function (val, oldval) {
      //   if (this.formData.oldPassword != val) {
      //     const record = {}
      //     record.msg = '请输入正确的旧密码'
      //     record.name = '系统提示'
      //     this.$refs.commonAlert.errorMsg(record)
      //   }
      // }
    },
    methods: {
      editPass(record) {
        console.log(record)
        this.mode = 'editPass'
        this.name = '编辑员工'
        this.visible = true
        this.formData = record
        this.formData.oldPassword = record.password
      },
      changeCount() {
        const comfPassword = this.form.getFieldValue('comfPassword')
        const password = this.form.getFieldValue('password')

        if (comfPassword != password) {
          alert('确认密码与密码不一致！！！')
          return false
        } else {
          return true
        }
      },
      changeOld() {
        const oldPassword = this.form.getFieldValue('oldPassword')
        const oldMd5Password = this.$md5(oldPassword).toUpperCase()
        if (this.formData.oldPassword != oldMd5Password) {
          alert('请输入正确的旧密码！！！')
          return false
        } else {
          return true
        }
      },
      handleSubmit() {

        if (!this.changeCount()) {
            return false
        }
        if (!this.changeOld()) {
          return false
        }

        this.confirmLoading = true
        this.form.validateFields((err, values) => { // 表单验证
          if (!err) {
            if (this.formData.id) {
              values.id = this.formData.id
            }
            const params = {}
            params.id = values.id
            params.password = this.$md5(values.password).toUpperCase()
            console.log(params)
            postAxios('resetPassword', params).then(res => {
              console.log(res)
              this.confirmLoading = false
              const record = {}
              record.msg = '密码修改成功'
              this.$refs.commonAlert.resetPass(record)
              this.handleCancel()
              // this.$message.success('修改成功')
              this.$emit('ok', '') // 成功回调
            }).catch(err => {
              console.log(err)
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      handleCancel() {
        this.visible = false
        this.confirmLoading = false
        this.form.resetFields() // 清空表单
        this.formData = {...formList}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/staff/modules/staffPassword.vue